export default {"src":"/_next/static/media/search-md.655ffa23.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};